const sliderWrapper = document.querySelector(".multicolumns__carousel");

const slidesPerView = parseInt(sliderWrapper.closest('.multicolumns').dataset.columnsPerRow, 10) || 1;

new Swiper(sliderWrapper, {
    slidesPerView: 1,
    spaceBetween: 16,
    centeredSlides: false,
    loop: false,
    speed: 500,
    breakpoints: {
        480: {
            slidesPerView: 2,
        },
        1024: {
            slidesPerView: slidesPerView
        }
    },
    pagination: {
        el: '.swiper-pagination',
        clickable: true
    },
});
